import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { EmailTemplateLayout } from "@rumble-it/common-lib/types/models/EmailTemplateLayout.interface";

export const fetchEmailTemplateLayouts = async (): Promise<
  CollectionResponse<EmailTemplateLayout>
> =>
  axiosInstance
    .get(`/admin/emails/template-layouts`)
    .then((response) => response.data);

export const createEmailTemplateLayout = async (
  data: EmailTemplateLayout,
): Promise<EmailTemplateLayout> =>
  axiosInstance
    .post(`/admin/emails/template-layouts`, data)
    .then((response) => response.data);

export const updateEmailTemplateLayoutById = async (
  id: string,
  data: EmailTemplateLayout,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/emails/template-layouts/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteEmailTemplateLayoutById = async (
  id: string,
): Promise<null> =>
  axiosInstance
    .delete(`/admin/emails/template-layouts/${id}`)
    .then((response) => response.data);

export const fetchEmailTemplateLayoutById = async (
  id: string,
): Promise<EmailTemplateLayout> =>
  axiosInstance
    .get(`/admin/emails/template-layouts/${id}`)
    .then((response) => response.data);
